import { render, staticRenderFns } from "./navreply.vue?vue&type=template&id=b70a723c&scoped=true"
import script from "./navreply.vue?vue&type=script&lang=js"
export * from "./navreply.vue?vue&type=script&lang=js"
import style0 from "./navreply.vue?vue&type=style&index=0&id=b70a723c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70a723c",
  null
  
)

export default component.exports